import React from 'react';
import PropTypes from 'prop-types';
import { Button, Space, Typography } from 'antd';
import {
	SettingOutlined,
	HomeOutlined,
	ReloadOutlined,
	InstagramOutlined,
	CustomerServiceOutlined,
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';

import { APP_INFORMATION_PAGE_LABELS } from '../../helper/appInformationPlacement';

import './styles.scss';

const { Paragraph, Text } = Typography;

const getMaintenanceMessage = (item) =>
	String(item?.description || item?.content || item?.title || '').trim();

const MaintenancePage = ({ target, item }) => {
	const navigate = useNavigate();
	const location = useLocation();

	const isGlobalOrRoot =
		target === 'landing' ||
		target === 'beranda' ||
		location.pathname === '/' ||
		location.pathname === '/beranda';
	const pageLabel = APP_INFORMATION_PAGE_LABELS[target];
	const titlePrefix = pageLabel ? `${pageLabel} sedang` : 'Sistem sedang';

	const message = getMaintenanceMessage(item);

	return (
		<main className="maintenance-page">
			<div className="maintenance-page__background-elements">
				<div className="maintenance-page__glow maintenance-page__glow--primary" />
				<div className="maintenance-page__glow maintenance-page__glow--secondary" />
				<div className="maintenance-page__grid" />
			</div>

			<div className="maintenance-page__container">
				<section className="maintenance-page__panel">
					<div className="maintenance-page__illustration">
						<div className="maintenance-page__gear maintenance-page__gear--large">
							<SettingOutlined spin />
						</div>
						<div className="maintenance-page__gear maintenance-page__gear--small">
							<SettingOutlined spin />
						</div>
					</div>

					<div className="maintenance-page__content">
						<h1 className="maintenance-page__title">
							{titlePrefix} dalam <span>Peningkatan Layanan</span>
						</h1>

						<Paragraph className="maintenance-page__description">
							Kami sedang melakukan pembaruan sistem untuk memberikan pengalaman
							belajar dan berlatih yang lebih stabil, cepat, dan nyaman untuk
							kamu. Silakan kembali beberapa saat lagi.
						</Paragraph>

						{message && (
							<div className="maintenance-page__message">
								<div className="maintenance-page__message-indicator" />
								<div className="maintenance-page__message-content">
									{message}
								</div>
							</div>
						)}
					</div>

					<div className="maintenance-page__actions">
						<Button
							size="large"
							className="maintenance-page__btn-reload"
							icon={<ReloadOutlined />}
							onClick={() => window.location.reload()}
						>
							Muat Ulang Halaman
						</Button>

						{!isGlobalOrRoot && (
							<Button
								type="primary"
								size="large"
								className="maintenance-page__btn-home"
								icon={<HomeOutlined />}
								onClick={() => navigate('/')}
							>
								Kembali ke Beranda
							</Button>
						)}
					</div>

					<div className="maintenance-page__divider" />

					<div className="maintenance-page__footer">
						<Text className="maintenance-page__footer-title">
							Butuh bantuan darurat?
						</Text>
						<Space size="middle" className="maintenance-page__socials">
							<Button
								type="text"
								icon={<InstagramOutlined />}
								href="https://instagram.com/cadira.id"
								target="_blank"
								className="maintenance-page__social-btn"
							>
								Info Update
							</Button>
							<Button
								type="text"
								icon={<CustomerServiceOutlined />}
								href="https://api.whatsapp.com/send/?phone=6289639592943&text=Halo+Admin+Cadira%2C+saya+mengalami+kendala+dan+butuh+bantuan+terkait+layanan+Cadira.&type=phone_number&app_absent=0"
								target="_blank"
								className="maintenance-page__social-btn"
							>
								Hubungi CS
							</Button>
						</Space>
					</div>
				</section>
			</div>
		</main>
	);
};

MaintenancePage.defaultProps = {
	target: '',
	item: null,
};

MaintenancePage.propTypes = {
	target: PropTypes.string,
	item: PropTypes.shape({}),
};

export default MaintenancePage;
